class ProductGallery {
	constructor(el) {
		this.el = el;
		this.thumbs = Array.from(
			this.el.querySelectorAll(
				`.product-gallery__thumbs input[type="radio"]`
			)
		);

		// this only needs to run if there are thumbs to interact with, otherwise it's just the standard image
		if (this.thumbs.length > 0) {
			this.mainImage = this.el.querySelector("figure img");
			this.init();
		}
	}

	init() {
		this.thumbs.forEach((t) => {
			t.addEventListener("change", () => {
				if (t.checked) {
					this.el.classList.add("loading");
					// load the thumbnail quickly
					const thumbSrc = t.parentElement.querySelector("img").src;
					this.mainImage.src = thumbSrc;
					this.loadImage(t.value);
				}
			});
		});

		this.thumbs[0].checked = true;

		this.el.classList.add("initialized");
	}

	loadImage(url) {
		const img = new Image();

		img.addEventListener("load", () => {
			this.mainImage.src = img.src;
			this.el.classList.remove("loading");
		});

		img.src = url;
	}
}

window.addEventListener("DOMContentLoaded", () => {
	let productGalleries = Array.from(
		document.querySelectorAll(".product-gallery")
	);

	productGalleries.forEach((p) => {
		new ProductGallery(p);
	});
});
